import React from "react";
import { Box, Text } from "@chakra-ui/react";

type AsideProps = {
  title: string;
  children: React.ReactNode;
};

const Aside = ({ title, children }: AsideProps) => {
  return (
    <Box color="gray.900" bg="purple.100" borderRadius="6">
      <Text fontSize="1em" fontWeight={600} p="4">
        {title}
      </Text>
      <Box
        p="4"
        fontSize="1em"
        borderTopStyle="solid"
        borderTopWidth="1px"
        borderTopColor="gray.300"
      >
        {children}
      </Box>
    </Box>
  );
};

export default Aside;
